<ng-container *transloco="let t">
  @if (hasProtocolTab) {
    <tui-segmented
      class="w-fit rounded-full! [--t-padding:1.5rem] [--t-gap: 0.5rem]"
      size="m"
      [activeItemIndex]="activeFormIndex()">
      <button data-testid="analysis-segment" type="button" (click)="showAnalysis()">
        {{ t('Analyse de la lésion') }}
        @if (showAnalysisErrorBadge()) {
          <tui-icon
            data-testid="analysis-error-badge"
            iconStart="@tui.circle-alert"
            size="l"
            tuiBadge
            tuiHintAppearance="negative"
            tuiHintDirection="bottom"
            [appearance]="'negative'"
            [tuiHint]="t('L\'analyse contient des champs invalides')" />
        }
      </button>
      <button data-testid="protocol-segment" type="button" (click)="showProtocol()">
        {{ t('Protocole de soin') }}
        @if (showProtocolErrorBadge()) {
          <tui-icon
            data-testid="protocol-error-badge"
            iconStart="@tui.circle-alert"
            size="l"
            tuiBadge
            tuiHintAppearance="negative"
            tuiHintDirection="bottom"
            [appearance]="'negative'"
            [tuiHint]="t('Le protocole contient des champs invalides')" />
        } @else if (showProtocolInfoBadge()) {
          <tui-icon
            data-testid="protocol-info-badge"
            iconStart="@tui.circle-alert"
            size="l"
            tuiBadge
            tuiHintDirection="bottom"
            [appearance]="'info'"
            [tuiHint]="t('Le protocole de soin n\'est pas encore rempli')" />
        }
      </button>
    </tui-segmented>
  }

  <pxc-form
    #analysisForm
    class="min-h-0 flex-1"
    data-testid="analysis-form"
    [class.hidden]="!isAnalysisFormActive()"
    [finishText]="finishText()"
    [form]="analysis.form"
    [formAnswer]="analysis.formAnswer"
    [formInputs]="moduleInputs"
    [readOnly]="isAnalysisReadOnly"
    [slideDirection]="slideDirection()"
    (completed)="onAnalysisCompleted($event)" />

  @if (hasProtocolTab && isProtocolMounted()) {
    @if (isProtocolReadOnly) {
      <pxc-sadm-entity-protocols
        class="min-h-0 flex-1"
        data-testid="protocol-history"
        [class.hidden]="!isProtocolFormActive()"
        [protocolReports]="protocolReports"
        [slideDirection]="slideDirection()"
        (closed)="closeProtocolHistory()" />
    } @else {
      <pxc-form
        #protocolForm
        class="min-h-0 flex-1"
        data-testid="protocol-form"
        [class.hidden]="!isProtocolFormActive()"
        [form]="protocol.form"
        [formAnswer]="protocol.formAnswer"
        [formInputs]="moduleInputs"
        [readOnly]="false"
        [slideDirection]="slideDirection()"
        (completed)="onProtocolCompleted($event)" />
    }
  }
</ng-container>
